/* Copyright 2013 - 2024 Waiterio LLC */
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React, { useState } from 'react'
import { Link } from 'react-router'
import { useTranslation } from '@multilocale/react/index.jsx'
import IconPapillon from '@stiloso/icons/IconPapillon.jsx'
import languages from '@monorepool/shared/languages.js'
import LanguageDialog from '../dialogs/LanguageDialog.jsx'

const navigation = css({
  label: 'navigation',
  color: 'white',
  backgroundColor: '#4393d0',
  display: 'flex',
  position: 'fixed',
  top: 0,
  width: '100%',
  padding: '10px 0px',
  justifyContent: 'space-between',
  height: 70,
  transition: 'padding .4s ease-in-out',
  zIndex: 1000,
})

const links = css({
  label: 'links',
  display: 'flex',
  alignItems: 'center',
  paddingRight: 100,
})

const link = css({
  label: 'link',
  color: 'white',
  margin: '10px 15px',
  fontSize: 16,
  height: 46,
  position: 'relative',

  ':after': {
    content: '""',
    position: 'absolute',
    top: 30,
    left: 0,
    width: 0,
    height: 2,
    backgroundColor: 'white',
    transition: 'width .3s',
  },

  ':hover:after': {
    width: '100%',
    transition: 'width .3s',
  },
})

const NavigationDesktopComponent = ({ locale }) => {
  const { t } = useTranslation(locale)
  const currentLanguage = languages[locale]

  const [languageDialog, setLanguageDialog] = useState()

  const toggleLanguageDialog = () => {
    setLanguageDialog(!languageDialog)
  }

  return (
    <div css={navigation}>
      <a href={`/${locale}/`}>
        <IconPapillon
          width="54"
          height="70"
          css={{ fill: 'white', paddingLeft: 100 }}
        />
      </a>
      <div css={links}>
        <div>
          <a css={link} href={`/${locale}/`}>
            {t('Home')}
          </a>
          <a css={link} href={`/blog/${locale}/`}>
            {t('Blog')}
          </a>
          <Link css={link} to={`/docs/${locale}/`}>
            {t('Documentation')}
          </Link>
          <a css={link} href={`/${locale}/pricing/`}>
            {t('Pricing')}
          </a>
          <a css={link} href={`/${locale}/downloads/`}>
            {t('Downloads')}
          </a>
          <a css={link} href="https://app.waiterio.com/signup">
            {t('Sign up')}
          </a>
          <a css={[link]} href="https://app.waiterio.com/login">
            {t('Login')}
          </a>
          <span
            onClick={toggleLanguageDialog}
            css={[link, { marginRight: 0, cursor: 'pointer' }]}
          >
            {currentLanguage} ▼
          </span>
        </div>

        {languageDialog && (
          <LanguageDialog currentLocale={locale} close={toggleLanguageDialog} />
        )}
      </div>
    </div>
  )
}

export default NavigationDesktopComponent
